<template>
    <div>
        <div v-if="field1" class="alert alert-info">
            Currentss Value: {{ field1 }}
        </div>

        <!-- <place-autocomplete-field
            v-model="field1"
            placeholder="Enter an an address, zipcode, or location"
            label="Address"
            name="field1"
            
            v-place-autofill.street="street"
        ></place-autocomplete-field> -->
        <p>
            <label>Street</label><br />
            <input name="street" v-model="street" class="form-control" />
        </p>
    </div>
</template>
<script>
export default {
    data() {
        return {
            field1: "",
            street: "",
            city: "",
            state: "",
            zip: "",
        }
    },
    watch: {
        field1: function (val) {
            console.log(this.field1, "sgjqkwejqklwjeklqwj")
        },
    },
}
</script>
